import { render, staticRenderFns } from "./messageView.vue?vue&type=template&id=6cb87ec6&scoped=true&"
import script from "./messageView.vue?vue&type=script&lang=js&"
export * from "./messageView.vue?vue&type=script&lang=js&"
import style1 from "./messageView.vue?vue&type=style&index=1&id=6cb87ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb87ec6",
  null
  
)

export default component.exports